/* tslint:disable */

declare var Object: any;
export interface ModuleCategoryInterface {
  "id"?: number;
  "name"?: number;
}

export class ModuleCategory implements ModuleCategoryInterface {
  "id": number;
  "name": number;
  constructor(data?: ModuleCategoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ModuleCategory`.
   */
  public static getModelName() {
    return "ModuleCategory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ModuleCategory for dynamic purposes.
  **/
  public static factory(data: ModuleCategoryInterface): ModuleCategory{
    return new ModuleCategory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ModuleCategory',
      plural: 'ModuleCategories',
      path: 'ModuleCategories',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ModuleCategory.ts